// Extract filter and order params using helper
export function getFilterAndOrderParams(searchParams: URLSearchParams) {
  const filterParam = searchParams.get('filter');
  let orderParam = searchParams.get('order');
  if (filterParam === null) {
    orderParam = null;
  }
  return { filterParam, orderParam };
}
